import styled from 'styled-components';

import { colorBlack900, colorGrey200, colorGrey400 } from 'styles/variables';

export const IconUp = styled.div`
  width: 0;
  height: 0;
  border-bottom: 4px solid ${colorGrey200};
  border-top: 4px solid transparent;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-bottom: 2px;
`;

export const IconDown = styled.div`
  width: 0;
  height: 0;
  border-top: 4px solid ${colorGrey200};
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-top: 2px;
`;

export const HeaderCell = styled.button`
  display: flex;
  border: none;
  background-color: white;
  outline: 0;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.03px;
  transition: color 0.3s;
  z-index: 2;
  align-items: center;
  color: ${colorGrey400};
  padding: 0 4px;

  &:hover {
    color: ${colorBlack900};
  }

  &[data-sort='asc'] {
    color: ${colorBlack900};

    ${IconUp} {
      border-bottom-color: ${colorBlack900};
    }
  }
  &[data-sort='desc'] {
    color: ${colorBlack900};

    ${IconDown} {
      border-top-color: ${colorBlack900};
    }
  }
`;

export const IconWrapper = styled.div`
  margin: -4px 0 0 4px;
`;
